import { createSlice } from '@reduxjs/toolkit'

export const sideBarReducer = createSlice({
    name: "sideBar",
    initialState: {
        "subModules": []
    },
    reducers: {
        updateSubmodule: (state,action) => {
            let subModulesData = [];
            action.payload.subModules.forEach((sub) => {
                if (sub.subModuleId === "S0021" || sub.subModuleId === "S0015" || sub.subModuleId === "S0014") {
                    sub.isActive = false;
                    sub.open = false;
                    return;
                }
                if (sub.subModuleTitle === "Reports & Export") {
                    sub.subModuleTitle = "Reports";
                    sub.name = "Reports";
                }

                subModulesData.push(sub);
            });
            state.subModules = subModulesData;
        }
    }
});

export const { updateSubmodule } = sideBarReducer.actions;

export default sideBarReducer.reducer;